












import { Vue, Prop, Component, Emit } from 'vue-property-decorator';
import SiteMapSkeltonLoader from '@/components/atoms/skelton/SiteMapSkeltonLoader.vue';
import SiteMapMenuListPanel from '@/components/organisms/SiteMapMenuListPanel.vue';
import { i18n } from '@/plugins/i18n/i18n';
import {
  ClickProductUrlEvent,
  MenuListItem,
  UpdateFavoriteEvent,
} from '@/types/type';

@Component({
  components: {
    SiteMapMenuListPanel,
    SiteMapSkeltonLoader,
  },
})
export default class SiteMapMenuList extends Vue {
  @Prop()
  private loading!: boolean;

  @Prop()
  private menu!: MenuListItem;

  @Emit('update-favorite')
  private updateFavorite(event: UpdateFavoriteEvent): UpdateFavoriteEvent {
    return event;
  }

  @Emit('click-url')
  private clickUrl(event: ClickProductUrlEvent): ClickProductUrlEvent {
    return event;
  }
}
